var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
var ContactDetailsService = /** @class */ (function () {
    function ContactDetailsService(http, activatedRoute) {
        this.http = http;
        this.activatedRoute = activatedRoute;
    }
    ContactDetailsService.prototype.getGeneralData = function (contactId) {
        return this.http.get("/contacts/" + contactId + "/details-box");
    };
    ContactDetailsService.prototype.getNumberDetailsData = function (contactId) {
        return this.http.get("/contacts/" + contactId + "/msisdn-config");
    };
    ContactDetailsService.prototype.addPrimaryMsisdn = function (contactId, msisdn) {
        return this.http.post("/contacts/" + contactId + "/msisdns", msisdn);
    };
    // deleteMsisdn(contactId: string, msisdn: { msisdn: string }): Observable<{ msisdn: string }> {
    //   return this.http.delete<{ msisdn: string }>(`/contacts/${contactId}/msisdns`, msisdn);
    // }
    ContactDetailsService.prototype.addNote = function (noteParam) {
        return this.http.post("/contacts/" + noteParam.recordId + "/note", { note: noteParam.note });
    };
    ContactDetailsService.prototype.isValidNumber = function (number, contactId) {
        return this.http.get("/contacts/" + contactId + "/valid-msisdn", {
            params: { msisdn: number, id: contactId.toString() }
        });
    };
    ContactDetailsService.prototype.getContactDetails = function (contactId) {
        return this.http.get("/contacts/" + contactId);
    };
    ContactDetailsService.prototype.getContactDetailsChangelog = function (eventId) {
        return this.http.get("/contacts/changelog/" + eventId);
    };
    ContactDetailsService.prototype.saveContactDetails = function (contactId, contactData) {
        return this.http.post("/contacts/" + contactId, contactData);
    };
    ContactDetailsService.prototype.getAvailableHistoryTypes = function (contactId) {
        return this.http.get("/contacts/" + contactId + "/event-types");
    };
    ContactDetailsService.prototype.getContactHistory = function (data) {
        var queryParams = this.getQueryParams(data);
        return this.http.get("/contacts/" + data.contactId + "/events", {
            params: queryParams
        });
    };
    ContactDetailsService.prototype.getQueryParams = function (data) {
        return Object.entries({
            limit: data.limit.toString(),
            pointId: data.eventId,
            searchDirection: data.searchDirection,
            type: data.type
        })
            .filter(function (_a) {
            var _ = _a[0], value = _a[1];
            return !!value;
        })
            .reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            var _b;
            return (__assign({}, acc, (_b = {}, _b[key] = value, _b)));
        }, {});
    };
    ContactDetailsService.prototype.getContactDetailsReport = function (recordData) {
        var headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf;charset=utf-8');
        return this.http.get((document.location.origin === environment.CHANNELS_URL
            ? environment.BACKEND_CHANNELS_URL
            : environment.BASE_BACKEND_URL) + "/contacts/" + recordData.id + "/history/pdf?timezoneOffsetMinutes=" + recordData.timezoneOffsetMinutes, { headers: headers, responseType: 'blob' });
    };
    ContactDetailsService.ngInjectableDef = i0.defineInjectable({ factory: function ContactDetailsService_Factory() { return new ContactDetailsService(i0.inject(i1.HttpClient), i0.inject(i2.ActivatedRoute)); }, token: ContactDetailsService, providedIn: "root" });
    return ContactDetailsService;
}());
export { ContactDetailsService };
